export const BASE_URL = 'https://api.hrnb.ru/api';
